import React, { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

type Properties = {
  userRole: number | undefined;
  accessRoles: number[];
};
export const ProtectRoute: FC<Properties> = ({ userRole, accessRoles }) => {
  if (!userRole || !accessRoles.includes(Number(userRole))) {
    return <Navigate to='/' />;
  }

  return <Outlet />;
};
